// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import FriendRequestStatus from "./friend_request_status_type";


export default __t.row({
  id: __t.u64().primaryKey(),
  fromUserId: __t.u64().name("from_user_id"),
  toUserId: __t.u64().name("to_user_id"),
  get status() {
    return FriendRequestStatus;
  },
  createdAt: __t.u64().name("created_at"),
  respondedAt: __t.option(__t.u64()).name("responded_at"),
});
